import { withTranslation } from 'react-i18next';
import './styles.scss';

const OnboardingHints = ({ t }) => {
  return <div className="onboarding-hints"/>;
};

export default withTranslation()(OnboardingHints);
